import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

import { OneTimePurchaseCardComponent } from './one-time-purchase-card/one-time-purchase-card.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { PurchasesSubscriptionCardComponent } from './purchases-subscription-card/purchases-subscription-card.component';

import {
  IBillingHistory,
  ITabChangedEvent,
  IUserSubscription
} from 'app/interfaces/profile.interfaces';
import { IButtonConfig } from 'app/shared/interfaces/button.interfaces';

import { EButtonTypes, EButtonSizes } from 'app/shared/enums/button.enums';
import { ETransactionCurrency } from 'app/enums/purchases.enums';

@Component({
  selector: 'stxt-purchases',
  standalone: true,
  imports: [
    NgbNavModule,
    CommonModule,
    ButtonComponent,
    PurchasesSubscriptionCardComponent,
    OneTimePurchaseCardComponent
  ],
  templateUrl: './purchases.component.html',
  styleUrl: './purchases.component.scss'
})
export class PurchasesComponent {
  @Input() subscriptionsList: IUserSubscription[];
  @Input() oneTimePurchase: IBillingHistory[];
  @Input() isViewAllPurchases: boolean = false;
  @Input() isViewAllSubscriptions: boolean = false;
  @Input() activeTab: number = 1;
  @Output() openSubscriptionManagementEvent: EventEmitter<IUserSubscription> =
    new EventEmitter<IUserSubscription>();
  @Output() openTransactionInfoEvent: EventEmitter<IBillingHistory> =
    new EventEmitter<IBillingHistory>();
  @Output() closeProfileEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() openSubscriptionCheckout: EventEmitter<IUserSubscription> =
    new EventEmitter<IUserSubscription>();
  @Output() openAllPurchasesEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() openAllSubscriptionsEvent: EventEmitter<void> = new EventEmitter<void>();

  public discoverBtnConfig: IButtonConfig = {
    text: 'Discover',
    fill: EButtonTypes.SecondaryFilled,
    buttonSize: EButtonSizes.Large
  };

  public viewAllBtnConfig: IButtonConfig = {
    text: 'View all',
    fill: EButtonTypes.SecondaryDark,
    buttonSize: EButtonSizes.Default
  };

  get active(): number {
    return this.activeTab;
  }

  set active(value: number) {
    this.activeTab = value;
  }

  get limitedOneTimePurchases(): IBillingHistory[] {
    if (this.isViewAllPurchases || !this.oneTimePurchase) {
      return this.oneTimePurchase || [];
    }
    return this.oneTimePurchase.slice(0, 3);
  }

  get limitedSubscriptions(): IUserSubscription[] {
    if (this.isViewAllSubscriptions || !this.subscriptionsList) {
      return this.subscriptionsList || [];
    }
    return this.subscriptionsList.slice(0, 3);
  }

  get shouldShowViewAllButton(): boolean {
    return !this.isViewAllPurchases && this.oneTimePurchase && this.oneTimePurchase.length > 3;
  }

  get shouldShowViewAllSubscriptionsButton(): boolean {
    return (
      !this.isViewAllSubscriptions && this.subscriptionsList && this.subscriptionsList.length > 3
    );
  }

  onTabChange(event: ITabChangedEvent): void {
    this.active = event.nextId;
  }

  isActive(tabIndex: number): boolean {
    return this.active === tabIndex;
  }

  openTransactionInfo(purchase: IBillingHistory): void {
    if (purchase.currency !== ETransactionCurrency.USD) return;
    this.openTransactionInfoEvent.emit(purchase);
  }

  openAllPurchases(): void {
    this.openAllPurchasesEvent.emit();
  }

  openAllSubscriptions(): void {
    this.openAllSubscriptionsEvent.emit();
  }
}
